export enum ReportingScreenUIState {
  MultipleDrawReporting = 1,
  SingleDrawReporting = 2,
  CharityReport = 3,
  LotteryLicenseReport = 4,
  PayoutReport = 5
}
